import { Clip, Event, Gift, Home, Market } from "@assets"
import { Link, router, usePage } from "@inertiajs/react"
import type React from "react"

import { Icon } from "@/components/icon"
import { cn } from "@/lib/utils"
import {
  eventsPath,
  marketplacePath,
  rafflesPath,
  rootPath,
  storiesNewPath,
} from "@/routes"
import type { NavItem } from "@/types"

function renderIcon(
  icon: React.ComponentType<{ className?: string }>,
  isActive?: boolean,
) {
  const colorClass = isActive
    ? "fill-foreground dark:fill-primary-foreground"
    : "fill-destructive-foreground dark:fill-muted-foreground"

  return (
    <Icon
      iconNode={icon}
      className={cn("mb-1 h-[24px] w-[24px]", colorClass)}
    />
  )
}

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
const navItems: NavItem[] = [
  {
    title: "INICIO",
    href: rootPath(),
    icon: Home,
  },
  {
    title: "EVENTOS",
    href: eventsPath(),
    icon: Event,
  },
  // CLIPS will be inserted here manually as a special button
  {
    title: "SORTEOS",
    href: rafflesPath(),
    icon: Gift,
  },
  // {
  //   title: "FORO",
  //   href: forumPath(),
  //   icon: Foro,
  // },
  {
    title: "MARKET",
    href: marketplacePath(),
    icon: Market,
  },
]
/* eslint-enable @typescript-eslint/no-unsafe-assignment */

export default function MobileBottomNav() {
  const page = usePage()

  const handleAddClip = () => {
    router.visit(storiesNewPath())
  }

  // Split nav items to insert Clips button between EVENTOS and SORTEOS
  const beforeClips = navItems.slice(0, 2) // INICIO, EVENTOS
  const afterClips = navItems.slice(2) // SORTEOS, FORO, MARKET

  return (
    <div className="bg-foreground dark:bg-card pb-safe fixed inset-x-0 bottom-0 z-50 shadow-md">
      <nav className="flex h-[57px] items-center justify-center overflow-x-hidden py-[6px]">
        {/* Items before Clips */}
        {beforeClips.map((item, index) => {
          const isHomeItem = item.href === "/"
          const isActive =
            (isHomeItem &&
              (page.url === "/" || page.url.startsWith("/feed"))) ||
            (!isHomeItem &&
              (page.url === item.href || page.url.startsWith(item.href)))

          return (
            <Link
              key={index}
              href={item.href}
              prefetch
              className={cn(
                "mr-[6px] ml-[6px] flex max-w-full min-w-0 flex-1 basis-0 flex-col items-center justify-center transition-all duration-200",
                isActive
                  ? "text-foreground dark:text-primary-foreground dark:bg-primary bg-card h-[45px] rounded-xl font-bold"
                  : "text-destructive-foreground dark:text-muted-foreground font-normal",
              )}
            >
              {item.icon &&
                renderIcon(
                  item.icon as React.ComponentType<{ className?: string }>,
                  isActive,
                )}
              <span className="h-[12px] max-w-full truncate text-[9px] tracking-[0.54px]">
                {item.title}
              </span>
            </Link>
          )
        })}

        {/* Clips Button - Add Story */}
        <button
          type="button"
          onClick={handleAddClip}
          className="text-destructive-foreground dark:text-muted-foreground mr-[6px] ml-[6px] flex max-w-full min-w-0 flex-1 basis-0 flex-col items-center justify-center font-normal transition-all duration-200"
        >
          {/* eslint-disable @typescript-eslint/no-unsafe-assignment */}
          <Icon
            iconNode={Clip}
            className="fill-destructive-foreground dark:fill-muted-foreground mb-1 h-[24px] w-[24px]"
          />
          {/* eslint-enable @typescript-eslint/no-unsafe-assignment */}
          <span className="h-[12px] max-w-full truncate text-[9px] tracking-[0.54px]">
            CLIPS
          </span>
        </button>

        {/* Items after Clips */}
        {afterClips.map((item, index) => {
          const isActive =
            page.url === item.href || page.url.startsWith(item.href)

          return (
            <Link
              key={`after-${index}`}
              href={item.href}
              prefetch
              className={cn(
                "mr-[6px] ml-[6px] flex max-w-full min-w-0 flex-1 basis-0 flex-col items-center justify-center transition-all duration-200",
                isActive
                  ? "text-foreground dark:text-primary-foreground dark:bg-primary bg-card h-[45px] rounded-xl font-bold"
                  : "text-destructive-foreground dark:text-muted-foreground font-normal",
              )}
            >
              {item.icon &&
                renderIcon(
                  item.icon as React.ComponentType<{ className?: string }>,
                  isActive,
                )}
              <span className="h-[12px] max-w-full truncate text-[9px] tracking-[0.54px]">
                {item.title}
              </span>
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
